import firebase from "firebase/app";
import { firebaseConfig } from "./firebase-config";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

firebase.initializeApp(firebaseConfig);

export const storage = firebase.storage();
export const db = firebase.firestore();
export const auth = firebase.auth();
export const quizCollection = db.collection('quizzes');

export function organizationCollection(uid) {
    return db.collection('organizations').where("members", "array-contains", uid);
};
export const globalSettingsDoc = db.collection("settings").doc("global");
export const globalMediaFilesCollection = db.collection("media-files");